import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
`;

export const MembersList = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid ${commonColors.grey300};

  &:first-of-type {
    padding-top: 0;
  }

  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  svg {
    width: 28px;
    height: 28px;
    min-height: 28px;
    min-width: 28px;
  }

  h1 {
    color: ${commonColors.grey900};
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0.08px;
    margin-bottom: 4px;
    word-break: break-word;
  }

  p {
    color: ${commonColors.grey700};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    letter-spacing: 0.07px;
    word-break: break-word;
  }
`;

export const Title = styled('div')`
  background: ${commonColors.lemonPie};
  color: ${commonColors.grey900};
  font-size: 24px;
  font-style: italic;
  font-weight: 500;
  line-height: 130%;
  margin-bottom: 16px;
`;

export const NameStyled = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 0 8px;
`;
